import React from 'react'
import PropTypes from 'prop-types'
import FeaturedCard from '../FeaturedCard/index'
import { Section, Grid, H2, P } from '../Globals/index.style'
import { Row, Col } from 'react-styled-flexboxgrid'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from 'styled-components'

const HeaderTitle = styled(H2)`
  text-align: left;
  line-height: 1;
`

const BlockFeatureCard = ({ title, subtitle, image, videoLink, content }) => {
  return (
    <Section>
      <Grid>
        <Row>
          <Col xs={12} lg={10}>
            <FeaturedCard
              image={`${image}?w=700&h=520`}
              title={title}
              videoLink={videoLink}
            >
              {title && <HeaderTitle>{title}</HeaderTitle>}
              {subtitle && <P>{subtitle}</P>}
              {content && <div>{documentToReactComponents(content)}</div>}
            </FeaturedCard>
          </Col>
        </Row>
      </Grid>
    </Section>
  )
}

BlockFeatureCard.PropTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.string,
  videoLink: PropTypes.string,
}

BlockFeatureCard.defaultProps = {
  image: false,
}

export default BlockFeatureCard
